// ⚠️ WARNING: API key in client-side code is visible to all users.
// Rotate this key if the app is ever deployed publicly.
export const CLAUDE_API_KEY = "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";
export const CLAUDE_HEADERS = {
  "Content-Type": "application/json",
  "x-api-key": CLAUDE_API_KEY,
  "anthropic-version": "2023-06-01",
  "anthropic-dangerous-direct-browser-access": "true",
};
